const INTERVAL = 5000;

export default class Sliders {
    constructor() {
        const domSliderList = [...document.querySelectorAll(".carousel")];

        for (const domSlider of domSliderList) {
            try {
                new Slider(domSlider);
            } catch (e) {
                console.log(e);
            }
        }
    }
}

class Slider {
    domSlider;
    domSliderInner;
    activeIndex = 0;

    // Swipe
    touchStartX = 0;
    touchCurrentX = 0;

    //
    isClickEvent = false;
    isSwipeEvent = false;

    sliderOffset = 0;

    constructor(domSlider) {
        if (!(this.domSlider = domSlider)) {
            return null;
        }

        this.domSliderInner = this.domSlider.querySelector(".inner");
        this.domSliderPrevButton = this.domSlider.querySelector(".prev-button");
        this.domSliderNextButton = this.domSlider.querySelector(".next-button");
        this.domSliderIndicators = this.domSlider.querySelectorAll(".indicator");

        this.Slider();
        this.Listen();
        this.AddPauseOnInteraction();
        this.smallSlider = document.querySelector(".carousel-small");

        if (this.smallSlider) {
            this.smallSliderInner = this.smallSlider.querySelector(".carousel-small-inner");
            this.smallSliderPrevButton = this.smallSlider.querySelector(".small-prev");
            this.smallSliderNextButton = this.smallSlider.querySelector(".small-next");

            this.caroiuselSmallItems = this.smallSlider.querySelectorAll(".carousel-small-button");
            this.caroiuselSmallItems.forEach((item, index) => {
                item.addEventListener("click", () => this.goToSlide(index));
                item.classList.toggle("active", index === this.activeIndex);
            });

            this.ListenSmallSlider();
        }
    }

    Listen() {
        this.domSliderPrevButton.addEventListener("click", event => {
            // !TODO Remove if unused (For debug)
            // this.isClickEvent = true;
            // this.isSwipeEvent = false;
            // console.log("Prev Click: isClickEvent =", this.isClickEvent, "isSwipeEvent =", this.isSwipeEvent);

            event.preventDefault();
            this.PrevSlide();
        });

        this.domSliderNextButton.addEventListener("click", event => {
            // !TODO Remove if unused (For debug)
            // this.isClickEvent = true;
            // this.isSwipeEvent = false;
            // console.log("Next Click: isClickEvent =", this.isClickEvent, "isSwipeEvent =", this.isSwipeEvent);

            event.preventDefault();
            this.NextSlide();
        });

        this.domSliderIndicators.forEach((indicator, index) => {
            indicator.addEventListener("click", () => this.goToSlide(index));
        });

        // Swipe
        this.domSlider.addEventListener("touchstart", this.handleTouchStart.bind(this));
        this.domSlider.addEventListener("touchmove", this.handleTouchMove.bind(this));
        this.domSlider.addEventListener("touchend", this.handleTouchEnd.bind(this));
    }

    NextSlide() {
        const length = this.domSliderInner.children.length;
        this.activeIndex = (this.activeIndex + 1) % length;
        this.UpdateActiveIndex();
    }

    PrevSlide() {
        const length = this.domSliderInner.children.length;
        this.activeIndex = (this.activeIndex - 1 + length) % length;
        this.UpdateActiveIndex();
    }

    ListenSmallSlider() {
        this.smallSliderPrevButton?.addEventListener("click", event => {
            event.preventDefault();
            this.PrevSlideSmall();
        });

        this.smallSliderNextButton?.addEventListener("click", event => {
            event.preventDefault();
            this.NextSlideSmall();
        });
    }

    NextSlideSmall() {
        this.moveSliderBy(1);
    }

    PrevSlideSmall() {
        this.moveSliderBy(-1);
    }

    goToSlide(index) {
        this.activeIndex = index;
        this.UpdateActiveIndex();
    }

    AddPauseOnInteraction() {
        const pauseSlider = () => {
            clearInterval(this.domSlider.intervalId);
        };

        const resumeSlider = () => {
            this.domSlider.intervalId = setInterval(() => this.NextSlide(), INTERVAL);
        };

        this.domSlider.addEventListener("mouseenter", pauseSlider);
        this.domSlider.addEventListener("mouseleave", resumeSlider);
        this.domSlider.addEventListener("touchstart", pauseSlider);
        this.domSlider.addEventListener("touchend", resumeSlider);
    }

    UpdateActiveIndex() {
        this.domSliderInner.style.transform = `translateX(calc(-1 * ${this.activeIndex} * (100% / ${this.domSliderInner.children.length})))`;

        this.domSliderIndicators.forEach((indicator, index) => {
            indicator.classList.toggle("active", index === this.activeIndex);
        });

        if (this.smallSlider) {
            this.setTranslateX(this.smallSliderInner, this.activeIndex);
            this.caroiuselSmallItems.forEach((item, index) => {
                item.children?.[0]?.classList.toggle("active", index === this.activeIndex);
            });
        }
    }

    // Swipe
    handleTouchStart(event) {
        // !TODO Remove if unused (For debug)
        // this.isClickEvent = false;
        // this.isSwipeEvent = true;
        // console.log("Touch Start: isClickEvent =", this.isClickEvent, "isSwipeEvent =", this.isSwipeEvent);

        this.isTouchMoved = false;

        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
    }

    handleTouchMove(event) {
        this.touchCurrentX = event.touches[0].clientX;
        this.touchCurrentY = event.touches[0].clientY;

        // !TODO Remove if unused (For debug)
        // console.log("Touch Move: isClickEvent =", this.isClickEvent, "isSwipeEvent =", this.isSwipeEvent);

        const deltaX = Math.abs(this.touchStartX - this.touchCurrentX);
        const deltaY = Math.abs(this.touchStartY - this.touchCurrentY);

        if (deltaX > deltaY) {
            // Horizontal swipe, prevent vertical scroll
            this.isTouchMoved = true;
            event.preventDefault();
        } else if (deltaY > deltaX) {
            // Vertical swipe, allow vertical scroll
            // console.log("VERTICAL SCROLL")
        }
    }

    handleTouchEnd() {
        if (this.isTouchMoved) {
            const swipeThreshold = 50; // Minimum swipe distance
            const deltaX = this.touchStartX - this.touchCurrentX;
            const deltaY = Math.abs(this.touchStartY - this.touchCurrentY);

            if (Math.abs(deltaX) > swipeThreshold && deltaY < Math.abs(deltaX)) {
                if (deltaX < 0) {
                    this.PrevSlide();
                } else if (deltaX > 0) {
                    this.NextSlide();
                }
            }
        }

        // !TODO Remove if unused (For debug)
        // console.log("Touch End: isClickEvent =", this.isClickEvent, "isSwipeEvent =", this.isSwipeEvent);
        // this.isClickEvent = false;
        // this.isSwipeEvent = false;

        // Reset touch states
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchCurrentX = 0;
        this.touchCurrentY = 0;

        this.isTouchMoved = false;
    }

    Slider() {
        this.domSlider.intervalId = setInterval(() => {
            this.NextSlide();
        }, INTERVAL);
    }

    setTranslateX(element, activeIndex) {
        const itemWidth = 150;
        const totalItems = element.children.length;
        const maxIndex = totalItems - 4;
        const validIndex = Math.min(activeIndex, maxIndex);
        const position = validIndex * itemWidth;

        element.style.transition = "transform 0.3s ease";
        element.style.transform = `translateX(-${position}px)`;
    }

    moveSliderBy(offset) {
        this.sliderOffset += offset;

        const itemWidth = 150;
        const totalWidth = this.smallSliderInner.scrollWidth;
        const visibleWidth = this.smallSliderInner.offsetWidth;
        const maxScroll = totalWidth - visibleWidth;

        let newScrollPosition = this.sliderOffset * itemWidth;

        if (newScrollPosition < 0) {
            newScrollPosition = 0;
            this.sliderOffset = 0;
        }

        if (newScrollPosition > maxScroll) {
            newScrollPosition = maxScroll;
            this.sliderOffset = Math.floor(maxScroll / itemWidth);
        }

        this.smallSliderInner.style.transition = "transform 0.3s ease";
        this.smallSliderInner.style.transform = `translateX(-${newScrollPosition}px)`;
    }
}
